import React from 'react';

import {
  Card,
  Image,
  ImageResizeOptions,
  PaddingModes,
  Text,
} from '@wix/wix-ui-tpa';
import { useStyles } from '@wix/tpa-settings/react';

import { messagesModel } from '@/features';

import styleParams from 'AiAssistantWidget/stylesParams';

import { ChatCard } from '../ChatCard';
import { ImageBlock } from '../ImageBlock';
import {
  LinkButton,
  WidgetButtonPriority,
  WidgetButtonSize,
} from '../WidgetButton';

import { st, classes } from './CardTemplatePayload.st.css';

export const CardTemplatePayload: React.FC<{
  title?: null | string;
  buttons?:
    | null
    | {
        type?: null | messagesModel.ButtonType;
        url?: null | string;
        title?: null | string;
      }[];
  orientation?: null | messagesModel.CardOrientation;
  icon?: null | string;
  textLines?: null | string[];
  imageUrl?: null | string;
}> = ({ title, buttons, icon, textLines, imageUrl, ...rest }) => {
  const styles = useStyles();
  const orientation =
    rest.orientation ?? messagesModel.CardOrientation.PORTRAIT;
  const buttonsCount = buttons?.length ?? 0;
  return (
    <ChatCard
      isSmall={orientation === messagesModel.CardOrientation.PORTRAIT}
      className={st(classes.root, {
        orientation:
          orientation === messagesModel.CardOrientation.PORTRAIT
            ? 'portrait'
            : 'landscape',
      })}
      cardClassName={st(classes.card)}
    >
      {imageUrl && (
        <Card.Container className={st(classes.sectionGallery)}>
          <ImageBlock
            className={st(classes.imageBlock)}
            aspectRatio={styles.get(styleParams.productImageAspectRatio)}
          >
            <Image
              src={imageUrl ?? undefined}
              resize={ImageResizeOptions.cover}
              width={orientation === 'PORTRAIT' ? 226 : 93}
              aspectRatio={styles.get(styleParams.productImageAspectRatio)}
            />
          </ImageBlock>
        </Card.Container>
      )}
      <Card.Container className={st(classes.section)}>
        {title && <Text>{title}</Text>}
        {textLines &&
          textLines.map((line, index) => (
            <Text className={st(classes.description)} key={index}>
              {line}
            </Text>
          ))}
        {buttons && buttonsCount > 0 && (
          <div className={st(classes.actionButtons)}>
            {buttons.map((button, index) => {
              const buttonType =
                buttonsCount === 1 ? messagesModel.ButtonType.CTA : button.type;
              let priority: WidgetButtonPriority;
              switch (orientation) {
                case messagesModel.CardOrientation.PORTRAIT:
                  switch (buttonType) {
                    case messagesModel.ButtonType.CTA:
                      priority = WidgetButtonPriority.basic;
                      break;
                    default:
                      priority = WidgetButtonPriority.secondary;
                  }
                  break;
                case messagesModel.CardOrientation.LANDSCAPE:
                default:
                  switch (buttonType) {
                    case messagesModel.ButtonType.CTA:
                      priority = WidgetButtonPriority.secondary;
                      break;
                    default:
                      priority = WidgetButtonPriority.primary;
                  }
                  break;
              }
              return (
                <LinkButton
                  key={index}
                  fullWidth={
                    orientation === messagesModel.CardOrientation.PORTRAIT
                  }
                  link={button.url ?? ''}
                  title={button.title ?? button.url ?? ''}
                  size={
                    orientation === messagesModel.CardOrientation.PORTRAIT
                      ? WidgetButtonSize.medium
                      : WidgetButtonSize.small
                  }
                  paddingMode={PaddingModes.explicitPaddings}
                  priority={priority}
                />
              );
            })}
          </div>
        )}
      </Card.Container>
    </ChatCard>
  );
};
